import { Action } from "redux";
import userTypes from "./userTypes";

interface IUser {
  payload: any;
}

export type TInitialUserAction = IUser & Action<userTypes.SET_USER>;
export const InitialUserAction = (data: any): TInitialUserAction => {
  return {
    type: userTypes.SET_USER,
    payload: data,
  };
};
export type TInitialPermissionsAction = IUser & Action<userTypes.SET_PERMISSIONS>;
export const InitialPermissionsAction = (data: any): TInitialPermissionsAction => {
  return {
    type: userTypes.SET_PERMISSIONS,
    payload: data,
  };
};

type LogoutUser = Action<userTypes.LOGOUT_USER>;
export const logoutUser = (): LogoutUser => ({
  type: userTypes.LOGOUT_USER,
});
